<label *ngIf="!!label"> {{ label | translate }} <span class="m--font-danger posRightErr"></span> </label>
<ck-editor id="hLane1" debounce="500" *ngIf="{value:editor$ | async} as editor" (ready)="onReady(editor?.value)" [ngModel]="editor?.value" (ngModelChange)="onChange($event)" skin="moono-lisa"
    [language]="language" [fullPage]="false" [config]="editorConfig" (focus)="onFocus()" (blur)="onBlur()" [ngClass]="{'editor--invalid': isInvalid}">
</ck-editor>
